export const HomeIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6 14.6667L6.00128 11.9984C6.00157 11.378 6.00172 11.0678 6.10308 10.8231C6.23849 10.4962 6.49831 10.2365 6.82527 10.1013C7.07007 10 7.38027 10 8.00067 10C8.62127 10 8.9316 10 9.17647 10.1013C9.50353 10.2367 9.76333 10.4965 9.89867 10.8235C10 11.0684 10 11.3787 10 11.9993V14.6667"
      stroke="#4A5466"
    />
    <path
      d="M4.72565 3.17512L4.05898 3.69548C3.04787 4.4847 2.54232 4.87932 2.27116 5.43572C2 5.99211 2 6.63486 2 7.92036V9.3145C2 11.8376 2 13.0992 2.78105 13.883C3.5621 14.6668 4.81917 14.6668 7.33333 14.6668H8.66667C11.1808 14.6668 12.4379 14.6668 13.2189 13.883C14 13.0992 14 11.8376 14 9.3145V7.92036C14 6.63486 14 5.99211 13.7289 5.43572C13.4577 4.87932 12.9521 4.4847 11.941 3.69548L11.2743 3.17512C9.7014 1.94737 8.91493 1.3335 8 1.3335C7.08507 1.3335 6.29858 1.94737 4.72565 3.17512Z"
      stroke="#4A5466"
      strokeLinejoin="round"
    />
  </svg>
);
